import React from 'react';
import cx from 'classnames';
import T from 'i18n-react';

import { Icons } from '@motorway/motorway-component-library';

import texts from '../../../texts.json';

import styles from '../StaticContents.module.scss';

T.setTexts(texts);

const ContactText = () => {
	const contactPhone = T.translate('contactInfo.phone');
	const contactEmail = T.translate('contactInfo.email');
	const headOfficeAddress = T.translate('contactInfo.headOfficeAddress');
	const brightonOfficeAddress = T.translate('contactInfo.brightonOfficeAddress');
	const boldLinkClass = 'mw-link mw-link-white mw-link-bold';

	return (
		<div className={cx(styles.staticContents, styles.container)}>
			<h1>Contact us</h1>
			<div>
				<p className={cx('mw-i', styles['mb-24'])}>
					You can always get in touch with our friendly team who will be happy to help.
				</p>

				<p className={cx('mw-i', styles['mb-16'], styles.lineWithIcon)}>
					<Icons.Phone />
					<a className={boldLinkClass} href={`tel:${contactPhone}`}>
						{contactPhone}
					</a>
				</p>
				<p className={cx('mw-i', styles['mb-16'], styles.lineWithIcon)}>
					<Icons.Envelope />
					<a className={boldLinkClass} href={`mailto:${contactEmail}`}>
						{contactEmail}
					</a>
				</p>
				<p />

				<h3 className={styles['mb-24']}>Our offices</h3>
				<h4 className={styles['mb-16']}>Head office:</h4>
				<address className={cx('mw-i', styles['mb-32'])}>{headOfficeAddress}</address>
				<h4 className={styles['mb-16']}>Brighton office:</h4>
				<address className={cx('mw-i', styles['mb-16'])}>
					{brightonOfficeAddress}
					<br />
				</address>

				<p className={styles.contactPageSocial}>
					<span>You can also find us on </span>
					<a
						className={boldLinkClass}
						href={T.translate('footerView.socialLinks.twitterLink')}
						rel="noopener noreferrer"
						target="_blank"
					>
						{T.translate('footerView.socialLinks.twitterTitle')}
					</a>
					<span>, </span>
					<a
						className={boldLinkClass}
						href={T.translate('footerView.socialLinks.facebookLink')}
						rel="noopener noreferrer"
						target="_blank"
					>
						{T.translate('footerView.socialLinks.facebookTitle')}
					</a>
					<span> and </span>
					<a
						className={boldLinkClass}
						href={T.translate('footerView.socialLinks.instagramLink')}
						rel="noopener noreferrer"
						target="_blank"
					>
						{T.translate('footerView.socialLinks.instagramTitle')}
					</a>
					<span>.</span>
				</p>
			</div>
		</div>
	);
};

export default ContactText;
